


































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Landing extends Vue {
  private height = 768;

  private width = 1366;

  private isMobile = window.matchMedia('only screen and (max-width: 760px)').matches;
  private landing = 'mobile-landing.mp4';
}
